// src/components/insights/ArticleLayout.jsx 

import { Link } from "react-router-dom";
import { resetFigureCounter } from "./figureCounter";
import { CitationProvider } from "./citationContext";

function ArticleLayout({ meta, children, readingTime }) {

  // 👇 RESET BEFORE RENDER
  resetFigureCounter();

  // 👉 NORMALITZEM AUTORS (sempre array)
  const authors = Array.isArray(meta.author)
    ? meta.author
    : meta.author
      ? [meta.author]
      : [];

  // 👉 FORMAT DISPLAY AUTORS
  const authorDisplay = authors
    .map(a => `${a.name}${a.role ? ` (${a.role})` : ""}`)
    .join(", ");

  return (
    <CitationProvider references={meta.references || {}}>
      <article className="article">

        {/* BREADCRUMBS */}
        <div className="breadcrumbs">
          <Link to="/">Home</Link>
          <span className="breadcrumb-separator">/</span>

          <Link to="/insights">Insights</Link>
          <span className="breadcrumb-separator">/</span>

          <span>{meta.title}</span>
        </div>

        {/* BACK LINK */}
        <Link to="/insights" className="back-link">
          ← All insights
        </Link>

        <header className="article-header">

          <div className="article-meta">

            {meta.category}

            {authorDisplay && (
              <>
                <span> · </span>
                {authorDisplay}
              </>
            )}

            <span> · </span>

            <time>
              {new Date(meta.publishedAt).toLocaleDateString()}
            </time>

            {meta.updatedAt && (
              <>
                <span> · Updated </span>
                <time>
                  {new Date(meta.updatedAt).toLocaleDateString()}
                </time>
              </>
            )}

            <span> · {readingTime}</span>

          </div>

          <h1 className="article-title">{meta.title}</h1>

          <p className="article-excerpt">{meta.excerpt}</p>

        </header>
        
        {meta.coverImage && (
          <div className="article-cover">
            <img
              src={meta.coverImage}
              alt={meta.title}
            />
          </div>
        )}
        {children}

      </article>
    </CitationProvider>
  );
}

export default ArticleLayout;